<button
  type="button"
  class="status-summary-card status-summary-card--{{ colorVariant }}"
  [class.status-summary-card--active]="active"
  (click)="cardClick.emit()">
  <div class="status-summary-card__info">
    <p class="status-summary-card__label">{{ label }}</p>
    <span class="status-summary-card__link">> VER TODAS</span>
  </div>
  <span class="status-summary-card__count">{{ count }}</span>
</button>
